import React, {Component} from 'react';

export default class extends Component {
	componentDidMount() {
		document.title = 'Сайт отключен';
	}

	render() {
		return (
			<div className="vertical-center">
				<div className="container text-center">
					<h1>Сайт отключен или временно недоступен</h1>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Off.js